import React, { useState } from 'react';

const History = () => {
  const [activeTab, setActiveTab] = useState('1998');

  const historyData = [
    {
      year: '1998',
      title: 'Authorized Dealer of Yuken India Ltd',
      img: 'assets/new-images/motors-baner/brandName3.png',
      desc: 'Became an authorized dealer of Yuken India Ltd, marking the beginning of a long-term association with a global hydraulic leader.',
      points: ['Global Hydraulic Leadership', 'Long-term Partnership']
    },
    {
      year: '2004',
      title: 'Authorized Dealer of Hydroline Products',
      img: 'assets/new-images/motors-baner/brandName4.jpeg',
      desc: 'Expanded its product portfolio by becoming an authorized dealer of Hydroline Products, strengthening expertise in filtration.',
      points: ['Hydraulic Filtration Expertise', 'Expanded Product Portfolio']
    },
    {
      year: '2005',
      title: 'Authorized Dealer of Prism Hydraulics',
      img: '/assets/new-images/deals-with/prism.avif',
      desc: 'Further growth led to a dealership with Prism Hydraulics, enhancing its offerings in hydraulic valves and pumps.',
      points: ['Hydraulic Valves & Pumps', 'Strategic Partnership']
    },
    {
      year: '2016',
      title: 'Authorized Dealer of Rexroth Mobile Hydraulics',
      img: 'assets/new-images/motors-baner/brandName2.webp',
      desc: 'Became an authorized dealer of Rexroth Mobile Hydraulics, a significant milestone in expanding into mobile solutions.',
      points: ['Mobile Hydraulic Solutions', 'Advanced Mobile Applications']
    },
    {
      year: '2021',
      title: 'Partnership with Tufit Fluid Conveyance',
      img: 'assets/new-images/motors-baner/brandName.webp',
      desc: 'Strengthened its portfolio with Tufit Fluid Conveyance Solutions, offering high-quality hydraulic fittings.',
      points: ['High-Quality Hydraulic Fittings', 'Fluid Conveyance Products']
    },
    {
      year: '2025',
      title: 'Direct OEM Supply Chain with Polyhydron',
      img: 'assets/new-images/motors-baner/bannerName3.png',
      desc: 'Started receiving Polyhydron products directly, strengthening our direct OEM supply chain and expanding our offerings.',
      points: ['Direct OEM Supply Chain', 'Expanded Hydraulic Offerings']
    }
  ];

  const currentContent = historyData.find(item => item.year === activeTab);

  return (
    <section className="ith-history-section section-space">
      <div className="container">
        <div className="text-center mb-50">
          <span className="ith-section-subtitle">OUR HISTORY</span>
          <h2 className="ith-section-title">Company Journey</h2>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-10">
            {/* Tab Navigation */}
            <div className="ith-history-tabs">
              {historyData.map((item) => (
                <button
                  key={item.year}
                  className={`ith-tab-btn ${activeTab === item.year ? 'active' : ''}`}
                  onClick={() => setActiveTab(item.year)}
                >
                  In {item.year}
                </button>
              ))}
            </div>

            {/* Tab Content Card */}
            <div className="ith-history-content-card mt-4">
              <div className="row align-items-center g-4">
                <div className="col-md-5 text-center">
                  <div className="ith-history-img-box">
                    <img src={currentContent.img} alt={currentContent.year} className="img-fluid" />
                  </div>
                </div>
                <div className="col-md-7">
                  <div className="ith-history-text-box">
                    <h3 className="ith-history-tab-title">{currentContent.title}</h3>
                    <p className="ith-history-desc">{currentContent.desc}</p>
                    <ul className="ith-history-points">
                      {currentContent.points.map((point, i) => (
                        <li key={i}>{point}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default History;